/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  ADD_FINANCIAL_TO_ASSET_SUCCESS,
  ADD_FINANCIAL_TO_ASSET_FAILURE,
  GET_ASSET_FINANCIALS_SUCCESS,
  GET_ASSET_FINANCIALS_FAILURE,
  UPDATE_ASSET_FINANCIAL_SUCCESS,
  UPDATE_ASSET_FINANCIAL_FAILURE,
  RESET_FINANCIALS,
  DELETE_ASSET_FINANCIAL_SUCCESS,
  DELETE_ASSET_FINANCIAL_FAILURE
} from "../actions/actionTypes";

const initialState = {
  financials: [],
  meta: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_FINANCIAL_TO_ASSET_SUCCESS:
      state.financials.push(action.payload.financial);
      return {
        addingFinancialSuccess: true,
        financials: state.financials,
        meta: action.payload.meta
      };

    case ADD_FINANCIAL_TO_ASSET_FAILURE:
      return {
        addingFinancialSuccess: false,
        error: action.err.message,
        financials: state.financials,
        meta: state.meta
      };

    case GET_ASSET_FINANCIALS_SUCCESS:
      return {
        getFinancialSuccess: true,
        financials: action.payload.financials,
        meta: action.payload.meta
      };

    case GET_ASSET_FINANCIALS_FAILURE:
      return {
        getFinancialSuccess: false,
        error: action.err.message,
        financials: state.financials,
        meta: state.meta
      };

    case UPDATE_ASSET_FINANCIAL_SUCCESS:
      let updatedFinIndex = state.financials.findIndex(
        f => f._id === action.payload.financial._id
      );
      state.financials[updatedFinIndex] = action.payload.financial;
      return {
        updateFinancialSuccess: true,
        financials: state.financials,
        meta: action.payload.meta
      };

    case UPDATE_ASSET_FINANCIAL_FAILURE:
      return {
        updateFinancialSuccess: false,
        error: action.err.message,
        financials: state.financials,
        meta: state.meta
      };

    case DELETE_ASSET_FINANCIAL_SUCCESS:
      let deletedFinIndex = state.financials.findIndex(
        f => f._id === action.payload.financial._id
      );
      if (deletedFinIndex >= 0) state.financials.splice(deletedFinIndex, 1);
      return {
        deleteFinancialSuccess: true,
        financials: state.financials,
        meta: state.meta
      };
    case DELETE_ASSET_FINANCIAL_FAILURE:
      return {
        deleteFinancialSuccess: false,
        financials: state.financials,
        meta: state.meta,
        error: action.err.message
      };

    case RESET_FINANCIALS:
      return {
        financials: []
      };

    default:
      return state;
  }
}
